import { alpha, type Theme } from '@mui/material/styles';
import { type PmpDealType, pmpDealType } from '@openx/types/deal.ts';
import { StatusPill, type StatusPillTone } from './StatusPill.tsx';

type DealTypePillConfig = {
  tone: StatusPillTone;
  backgroundColor?: (theme: Theme) => string;
  color?: (theme: Theme) => string;
};

const dealTypePillConfig: Partial<Record<PmpDealType, DealTypePillConfig>> = {
  [pmpDealType.Guaranteed]: {
    tone: 'cyan',
    backgroundColor: theme => alpha(theme.palette.charts.lightBlue, 0.12),
    color: theme => theme.palette.charts.lightBlue,
  },
  [pmpDealType.PreferredDeal]: {
    tone: 'violet',
    backgroundColor: theme => theme.palette.charts.lavender,
    color: theme => theme.palette.charts.magenta,
  },
  [pmpDealType.PrivateAuction]: {
    tone: 'success',
    backgroundColor: theme => theme.palette.success.light,
    color: theme => theme.palette.success.dark,
  },
  [pmpDealType.WithinOpenAuction]: {
    tone: 'indigo',
    backgroundColor: theme => theme.palette.info.light,
    color: theme => theme.palette.info.main,
  },
};

const getDealTypePillConfig = (value?: PmpDealType | string): DealTypePillConfig | undefined =>
  value ? dealTypePillConfig[value as PmpDealType] : undefined;

export interface DealListDealTypePillProps {
  label: string;
  value?: PmpDealType | string;
}

export const DealListDealTypePill = ({ label, value }: DealListDealTypePillProps) => {
  const config = getDealTypePillConfig(value);

  return (
    <StatusPill
      component="span"
      label={label}
      tone={config?.tone ?? 'neutral'}
      sx={theme => ({
        backgroundColor: config?.backgroundColor?.(theme),
        color: config?.color?.(theme),
      })}
    />
  );
};
